import React from 'react';

import CloseBtn from '../../../assets/images/CloseBtn.svg';
import ErrorImage from '../../../assets/images/ErrorImage.svg';

import styles from './ErrorPopup.module.scss';

function ErrorPopup(props) {
  const { show, closePopup } = props;
  return (
    <div className={show ? styles.errorPopupVisible : styles.errorPopupHidden}>
      <div className={styles.errorPopupCard}>
        <div className={styles.closeBtn} onClick={closePopup}>
          <CloseBtn />
        </div>
        <div className={styles.contentWrapper}>
          <div>
            <ErrorImage />
          </div>
          {/* <div className={styles.errorText}>
            Request submitted successfully!
          </div> */}
          <div className={styles.mainText}>Found Error</div>
          <div className={styles.supportText}>Something went wrong please try again</div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPopup;
